class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.openedMS = 0;
    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this)),
    );

    this.updatePosition();
    this.setupPositionListener();
  }

  open() {
    // Update position before opening to ensure it's aligned with product-categories-nav
    this.updatePosition();
    
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true },
    );

    document.body.addEventListener("click", this.onBodyClick);
    this.openedMS = new Date().getTime();
  }

  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key || parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${
          this.cartItemKey
        }"], .cart-notification-product-${
          this.cartItemKey ? this.cartItemKey.replace(":", "\\:") : ""
        }`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (new Date().getTime() < this.openedMS + 4000) {
      return;
    }
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updatePosition() {
    const productCategoriesNav = document.querySelector(".product-categories-nav");
    if (!this.notification) return;

    // If product-categories-nav exists and is visible, position below it
    if (productCategoriesNav) {
      const navRect = productCategoriesNav.getBoundingClientRect();
      // Check if the nav is actually visible (not hidden)
      if (navRect.height > 0 && window.getComputedStyle(productCategoriesNav).display !== 'none') {
        const navBottom = navRect.bottom;
        // Set the top position of cart notification to the bottom of product-categories-nav
        this.notification.style.top = `${navBottom}px`;
        return;
      }
    }

    // Fallback: if nav doesn't exist or is hidden, use a default position
    // This could be based on header height or a fixed offset
    const stickyHeader = document.querySelector("sticky-header");
    const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 80;
    this.notification.style.top = `${headerHeight}px`;
  }

  setupPositionListener() {
    // Update position on scroll and resize
    let resizeTimer;
    const handleUpdate = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.updatePosition();
      }, 100);
    };

    window.addEventListener("scroll", handleUpdate, { passive: true });
    window.addEventListener("resize", handleUpdate);
    
    // Also update when the page loads fully
    if (document.readyState === "complete") {
      this.updatePosition();
    } else {
      window.addEventListener("load", () => this.updatePosition());
    }
  }
}

customElements.define("cart-notification", CartNotification);
